import styled from "@emotion/styled";
import { useFormikContext } from "formik";

import { SkiliticsIcon } from "../icons";
import { FONT_WEIGHT_SEMI_BOLD } from "../utilities";

const Alert = styled.div`
  background: ${({ theme }) => theme.errorContainer};
  color: ${({ theme }) => theme.error};
  border-radius: ${({ theme }) => theme.borderRadius}px;
  display: flex;
  align-items: center;
  column-gap: 8px;
  padding: 6px 8px;
  width: 100%;
  font-weight: ${FONT_WEIGHT_SEMI_BOLD};
  i {
    font-size: 14px;
  }
  ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }
  li {
    margin: 0;
    padding: 0;
  }
`;

type Props = {
  errors: string[];
};

export const FormValidationErrorMessages = ({ errors }: Props) => {
  if (!errors.length) {
    return null;
  }

  return (
    <Alert>
      <SkiliticsIcon icon="error" />
      {errors.length === 1 ? (
        errors.map((error, index) => <span key={index}>{error}</span>)
      ) : (
        <ul>
          {errors.map((error, index) => (
            <li key={index}>- {error}</li>
          ))}
        </ul>
      )}
    </Alert>
  );
};

export const FormikErrorMessages = () => {
  const { errors } = useFormikContext();
  const errorCount = Object.keys(errors).length;

  if (!errorCount) {
    return null;
  }

  return <FormValidationErrorMessages errors={Object.values(errors)} />;
};
